import * as React from "react";

class EditableSectionForm extends React.Component {
    render() {
        return this.props.children || null;
    }
}

export default EditableSectionForm;